import React from "react";
import { renderLayout } from "schema/ThemeSet.react";
import InputField from "slides/components/InputField.react";

export default class OpenAnswer extends React.Component {
    handleClick = (answer) => {
        this.props.trackInteraction(answer);
    };

    render() {
        let isPortrait =
            this.props.mobileView || window.innerHeight > window.innerWidth;
        let LayoutRender = renderLayout(isPortrait, this.props.layout);

        return (
            <div className="full-height">
                <LayoutRender
                    {...this.props}
                    title={"Let us know:"}
                    mainContent={
                        <InputField
                            {...this.props}
                            handleClick={this.handleClick}
                            smallField={false}
                        />
                    }
                />
            </div>
        );
    }
}
